import { useMemo } from 'react';
import { EventRoleStatus, STATUS } from '@type/db-types';
import { addUpdateEvent, fetchManageableEvents } from '@modules/supabase/events';
import { Column } from '@material-table/core';
import { STATUS_LOOKUP } from '@utils/team-table-utils';
import { IconButton, Tooltip } from '@mui/material';
import { Delete } from '@mui/icons-material';
import { PublicationStatusChip } from '@utils/event-table-utils';
import EventsList from './EventsList';

export default function ManageEvents() {
    const ADMIN_COLUMNS: Column<EventRoleStatus>[] = useMemo(
        () => [
            {
                lookup: STATUS_LOOKUP,
                title: 'Publication Status',
                field: 'eventStatus',
                render: ({ eventStatus }) => PublicationStatusChip(eventStatus),
            },
            {
                title: 'Cancel',
                field: 'eventStatus',
                render: ({ id }) => (
                    <Tooltip title="Cancel Event">
                        <IconButton
                            onClick={(e) => {
                                e.preventDefault();
                                e.stopPropagation();
                                if (window.confirm('Are you sure you want to cancel this event?'))
                                    addUpdateEvent({ id, status: STATUS.CANCELLED }).then(() =>
                                        window.location.reload(),
                                    );
                            }}
                            color="error"
                            size="large"
                        >
                            <Delete />
                        </IconButton>
                    </Tooltip>
                ),
            },
        ],
        [],
    );

    return (
        <EventsList fetchEvents={fetchManageableEvents} columns={ADMIN_COLUMNS} managingEvents />
    );
}
